<template>
  <section id="referenceimg">
    <div  v-for="(imgGroup, index) in imgGroups" :key="`${index}`">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="10" align="center" justify="center" class="mt-12 mb-5">
            <h1 class="font-weight-bold display-1">{{ imgGroup.title }}</h1>
          </v-col>
        </v-row>
      </v-container>
    <v-container fluid>
        <v-row>
          <v-col v-for="(image, imgIndex) in imgGroup.images" :key="`image-${imgIndex}`" :md="image.cols" xs="12"  class="mb-4">
            <v-img
              align="center" justify="center"
              :src="image.source"
              height="100%"
              max-height="600px"
              contain
            ></v-img>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      imgGroups: [
        {
          title: "Láncvezérlés teljes cseréje:",
          images: [
            { cols: 3 },
            { source: require('@/assets/img/lanc1.jpg'), cols: 3 },
            { source: require('@/assets/img/lanc2.jpg'), cols: 3 },
            { cols: 3 },
          ]
        },
        {
          title: "Hidrotőke cseréje kis szervizzel egybekötve:",
          images: [
            { cols: 3 },
            { source: require('@/assets/img/hidro1.jpg'), cols: 3 },
            { source: require('@/assets/img/hidro2.jpg'), cols: 3 },
            { cols: 3 },
          ]
        },
        {
          title: "Turbo csere:",
          images: [
            { cols: 3 },
            { source: require('@/assets/img/turbo1.jpg'), cols: 3 },
            { source: require('@/assets/img/turbo2.jpg'), cols: 3 },
            { cols: 3 },
          ]
        },
        {
          title: "Diagnosztika, Vezetékek-, jeladók-, multimédiás eszközök javítása és cseréje:",
          images: [
            { source: require('@/assets/img/diagnostic1.jpg'), cols: 3 },
            { source: require('@/assets/img/diagnostic2.jpg'), cols: 3 },
            { source: require('@/assets/img/diagnostic3.jpg'), cols: 6 },
          ]
        },
        {
          title: "AdBlue befecskendező egységnél hűtőközeg tömítetlenség, illetve kristályosodás:",
          images: [
            { source: require('@/assets/img/adblue1.jpg'), cols: 6 },
            { source: require('@/assets/img/adblue2.jpg'), cols: 6 },
          ]
        },
        {
          title: "Munkagépek szervizelése:",
          images: [
            { source: require('@/assets/img/munka1.jpg'), cols: 3 },
            { source: require('@/assets/img/munka2.jpg'), cols: 3 },
            { source: require('@/assets/img/munka3.jpg'), cols: 6 },
          ]
        },
      ] 
    }
  }
}
</script>

<style scoped>
.v-img {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>